import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';
import { ToolsService } from 'src/app/services/tools.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
export class NewsDetailPage {
    constructor(navParams, modalController, toolsService, authService, analyticsService) {
        this.navParams = navParams;
        this.modalController = modalController;
        this.toolsService = toolsService;
        this.authService = authService;
        this.analyticsService = analyticsService;
        this.analyticsService.AnalyticsPageView('news-detail');
        this.currentNewId = this.navParams.data.news.id;
    }
    ngOnInit() {
        this.loadNew();
    }
    loadNew() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.toolsService.showLoader();
            if (typeof this.currentNewId != 'number') {
                yield this.toolsService.dismissLoader();
                return;
            }
            let response = yield this.authService.getNews(this.currentNewId);
            this.singleNew = response;
            // Extract video URL from iframe in content
            const regex = /<iframe.+?src="(.+?)".*?><\/iframe>/gi;
            const match = regex.exec(this.singleNew.content);
            const videoUrl = match ? match[1] : null;
            // Validate video URL
            // If any other platform is needed, just add it to the regex
            let isValidVideoUrl = false;
            if (videoUrl) {
                const videoRegex = /^(https?:\/\/)?((www\.)?youtube\.com|youtu\.be|player\.vimeo\.com|www\.dailymotion\.com)\/.+$/i;
                isValidVideoUrl = videoRegex.test(videoUrl);
            }
            // Set valid video URL in component state
            this.validVideoUrl = isValidVideoUrl ? videoUrl : null;
            yield this.toolsService.dismissLoader();
        });
    }
    closeModal() {
        this.modalController.dismiss();
    }
}
